<template>
  <div>
    <el-menu unique-opened router background-color="#545c64" text-color="#fff" active-text-color="rgb(120, 175, 227)">
      <el-submenu index="pay">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>发放管理</span>
        </template>
        <el-menu-item index="payexcels">资金发放</el-menu-item>
        <el-menu-item index="paydetail">明细查询</el-menu-item>
        <el-menu-item index="limituser">结算规则</el-menu-item>
      </el-submenu>
      <el-submenu index="money">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>资金管理</span>
        </template>
        <el-menu-item index="recharges" v-if="ischeck == 0">账户充值</el-menu-item>
        <el-menu-item index="rechargeverify" v-if="ischeck == 1 || supermanager == 1">充值审核</el-menu-item>
        <el-menu-item index="moneyview">资金汇总</el-menu-item>
      </el-submenu>

      <el-submenu index="usermanage">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>人员管理</span>
        </template>
        <el-menu-item index="usermanage">人员管理</el-menu-item>
      </el-submenu>

<!--
      <el-submenu index="invoice">
        <template slot="title">
          <i class="el-icon-bank-card"></i>
          <span>发票管理</span>
        </template>
        <el-menu-item index="invoiceApply">开票申请</el-menu-item>
        <el-menu-item index="invoiceManage">类目维护</el-menu-item>
      </el-submenu>

      <el-submenu index="dutyPaid">
        <template slot="title">
          <i class="el-icon-bank-card"></i>
          <span>完税证明</span>
        </template>
        <el-menu-item index="providerProof">服务商完税证明 </el-menu-item>
      </el-submenu>

      <el-submenu index="contractManage">
        <template slot="title">
          <i class="el-icon-bank-card"></i>
          <span>合同管理</span>
        </template>
        <el-menu-item index="enterpList">企业合同</el-menu-item>
      </el-submenu>
-->

      <el-submenu index="user">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>账号设置</span>
        </template>
        <el-menu-item index="basicinfo">基本信息</el-menu-item>
        <el-menu-item index="pwdmodify">密码修改</el-menu-item>
      </el-submenu>

      <!-- <el-submenu index="manage" v-if="supermanager == 1 || ismanager == 1"> -->
      <el-submenu index="manage" v-if="supermanager == 1 || ismanager == 1">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>账号管理</span>
        </template>
        <el-menu-item index="accounts">账号列表</el-menu-item>
        <el-menu-item index="addprovider" v-if="supermanager == 1">新增供应商</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  data() {
    return {
      supermanager: 0,
      ischeck: 0,
      ismanager: 0,
      plat: 1, // 1：迅果，2：启丰
    };
  },
  mounted() {
    this.fetchUser();
    // this.ischeck = this.$store.state.ischeck;
    // this.supermanager = this.$store.state.supermanager;
    // this.ismanager = this.$store.state.ismanager;
    console.log('my ischekc', this.ischeck);
    this.$store.commit('setPlat', this.plat);
  },
  methods: {
    fetchUser() {
      api
        .fetchUser()
        .then((res) => {
          console.log('fetchUser', res);
          if (res.checkRight === 1) {
            this.$store.commit('setIscheck', 1);
          } else {
            this.$store.commit('setIscheck', 0);
          }
          this.ischeck = res.checkRight;
          if (res.payRight === 1) {
            this.$store.commit('setIspay', 1);
          } else {
            this.$store.commit('setIspay', 0);
          }
          if (res.superManager === 1) {
            this.$store.commit('setSupermanager', 1);
          } else {
            this.$store.commit('setSupermanager', 0);
          }
          this.supermanager = res.superManager;
          if (res.isManager === 1) {
            this.$store.commit('setIsmanager', 1);
          } else {
            this.$store.commit('setIsmanager', 0);
          }
          this.ismanager = res.isManager;
          this.$store.commit('setAccountName', res.account);
          if (this.ischeck) {
            this.fetchUnhandleRecharges();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    fetchUnhandleRecharges() {
      api
        .fetchUnhandleRecharges()
        .then((res) => {
          console.log('fetchUnhandleRecharges', res);
          if (res > 0) {
            this.$alert('  您有充值转账需要审核，请及时处理！', '温馨提示：', {
              confirmButtonText: '确定',
              // callback: action => {
              //   this.$message({
              //     type: 'info',
              //     message: `action: ${ action }`,
              //   });
              // },
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
  },
};
</script>

<style>
.el-message-box__message p {
  font-size: 17px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/menubar.vue